import { Pagination } from "react-bootstrap";

export default function PaginationSelector(props) {
    

    const {numItems, index, setIndex, pageSize=50} = props;
    const maxIndex = Math.max(Math.floor((numItems - 1) / pageSize), 0);

    return (
        <Pagination>
            {index > 2 && <Pagination.First onClick={() => {setIndex(0)}}/>}
            {index > 2 && <Pagination.Prev onClick={() => {setIndex(index-1)}}/>}
            {index > 2 && <Pagination.Ellipsis onClick={() => {setIndex(index-3)}}/>}


            {index > 1 && <Pagination.Item onClick={() => {setIndex(index-2)}}>{index-1}</Pagination.Item>}
            {index > 0 && <Pagination.Item onClick={() => {setIndex(index-1)}}>{index}</Pagination.Item>}
            <Pagination.Item className="active">{index+1}</Pagination.Item>
            {index < maxIndex && <Pagination.Item onClick={() => {setIndex(index+1)}}>{index+2}</Pagination.Item>}
            {index < maxIndex - 1 && <Pagination.Item onClick={() => {setIndex(index+2)}}>{index+3}</Pagination.Item>}

            {index < maxIndex - 2 && <Pagination.Ellipsis onClick={() => {setIndex(index+3)}}/>}
            {index < maxIndex - 2 && <Pagination.Next onClick={() => {setIndex(index+1)}}/>}
            {index < maxIndex - 2 && <Pagination.Last onClick={() => {setIndex(maxIndex)}}/>}
        </Pagination>
    );
}